"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baggageEntryMetadataFromString = exports.createBaggage = void 0;

var baggage_1 = require("./internal/baggage");

var symbol_1 = require("./internal/symbol");

__exportStar(require("./Baggage"), exports);

__exportStar(require("./Entry"), exports);
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */


function createBaggage(entries) {
  if (entries === void 0) {
    entries = {};
  }

  return new baggage_1.BaggageImpl(new Map(Object.entries(entries)));
}

exports.createBaggage = createBaggage;
/**
 * Create a serializable BaggageEntryMetadata object from a string.
 *
 * @param str string metadata. Format is currently not defined by the spec and has no special meaning.
 *
 */

function baggageEntryMetadataFromString(str) {
  if (typeof str !== 'string') {
    // @TODO log diagnostic
    str = '';
  }

  return {
    __TYPE__: symbol_1.baggageEntryMetadataSymbol,
    toString: function toString() {
      return str;
    }
  };
}

exports.baggageEntryMetadataFromString = baggageEntryMetadataFromString;